import type { Url } from '@shady-pines/types';
import { isNil } from 'lodash';
import type { StorageBucket } from '../types';
import { useSupabase } from '../use-supabase';

export const useSupabaseStorageUrl = (bucket: StorageBucket, path?: string | null) => {
  const supabase = useSupabase();
  if (isNil(path)) {
    return undefined;
  }

  const { data } = supabase.storage.from(bucket).getPublicUrl(path);

  return data.publicUrl as Url;
};
